// Ameaça mundial: barra de vida global, fase, o seu dano e a entrada na batalha final.
// Visual de alerta global: vermelho pulsante, sirene e barra de vida gigante. CSS em client/css-parts/quests.css (prefixo .th-).
import { useEffect, useState } from 'preact/hooks';
import { THREAT_FINAL_PCT, THREAT_FALL_MS, type ThreatState } from '../../../../shared/src/game/threat';
const n = (v: number) => Math.round(v).toLocaleString('pt-BR');
const left = (ms: number) => { const h = Math.max(0, Math.floor(ms / 3600_000)), m = Math.max(0, Math.floor((ms % 3600_000) / 60000)); return `${h}h${String(m).padStart(2, '0')}`; };

export function Threat(props: { st: { state: ThreatState | null; next: number; fallUntil?: number } | null; inCity: boolean; onEnter: () => void }) {
  const [help, setHelp] = useState(false);
  // relógio local só para os contadores (a cada segundo)
  const [, tick] = useState(0);
  useEffect(() => { const t = setInterval(() => tick((x) => x + 1), 1000); return () => clearInterval(t); }, []);
  const s = props.st?.state;
  if (!props.st) return <p class="muted">Carregando...</p>;

  const steps = (
    <div class="th-steps">
      <div><i>⚔️</i><b>1. Cace</b><small>Todo o servidor causa dano ao boss: cada abate em qualquer hunt conta (a experiência do monstro).</small></div>
      <div><i>🏟️</i><b>2. Batalha final</b><small>Os últimos {THREAT_FINAL_PCT}% são uma batalha ao vivo na arena. Quem cai sai por {THREAT_FALL_MS / 60_000} minutos e volta, sem perda.</small></div>
      <div><i>💰</i><b>3. Recompensa</b><small>Proporcional ao seu dano: gold, fragmentos de pedra de proteção e prey cards.</small></div>
    </div>
  );

  if (!s) return (
    <div class="th th-calm">
      <div class="th-head">
        <div class="th-radar"><i /></div>
        <div class="th-head-txt">
          <div class="th-title">Ameaça Mundial <button class="th-help" onClick={() => setHelp(!help)} title="Como funciona">?</button></div>
          <div class="th-sub">Os vigias de Noxara observam o horizonte. Por enquanto, tudo calmo.</div>
        </div>
      </div>
      {help && steps}
      <div class="th-wait">
        <small>Nenhuma ameaça no momento</small>
        <b>{left(props.st.next - Date.now())}</b>
        <span>até a próxima chegar</span>
      </div>
      <p class="th-note">Todo o servidor causa dano ao boss: cada abate em qualquer hunt conta, e os últimos {THREAT_FINAL_PCT}% são uma batalha ao vivo na arena.</p>
    </div>
  );

  const pct = (s.hp / s.max) * 100;
  const fall = (props.st.fallUntil ?? 0) - Date.now();
  const dealt = Math.max(0, s.max - s.hp);
  const share = dealt > 0 ? Math.min(100, (s.myDamage / dealt) * 100) : 0;
  return (
    <div class={'th' + (s.final ? ' th-final' : '')}>
      <div class="th-head">
        <div class="th-siren"><span>⚠</span></div>
        <div class="th-head-txt">
          <div class="th-alert">ALERTA GLOBAL · {s.final ? 'BATALHA FINAL' : 'FASE 1'}</div>
          <div class="th-title">{s.boss} <button class="th-help" onClick={() => setHelp(!help)} title="Como funciona">?</button></div>
          <div class="th-sub">{s.final ? 'O boss está na arena! Todos os heróis, à batalha.' : 'Cada abate em qualquer hunt causa dano (a experiência do monstro).'}</div>
        </div>
        <div class="th-clock"><small>acaba em</small><b>{left(s.ends - Date.now())}</b></div>
      </div>

      {help && steps}

      <div class="th-hp">
        <div class="th-bar">
          <i style={{ width: pct + '%' }} />
          <em class="th-mark" style={{ left: THREAT_FINAL_PCT + '%' }} title={`Batalha final nos últimos ${THREAT_FINAL_PCT}%`} />
          <span>{n(s.hp)} / {n(s.max)} ({pct.toFixed(1)}%)</span>
        </div>
        <div class="th-phases">
          <span class={s.final ? 'on' : ''}>🏟️ Batalha final (últimos {THREAT_FINAL_PCT}%)</span>
          <span class={!s.final ? 'on' : ''}>⚔️ Fase 1: abates em todo o servidor</span>
        </div>
      </div>

      <div class="th-stats">
        <div class="th-me"><small>Seu dano</small><b>{n(s.myDamage)}</b><span>{s.myDamage ? `≈ ${share.toFixed(share < 1 ? 2 : 1)}% do total` : 'cace para participar'}</span></div>
        <div><small>Sua posição</small><b>{s.rank ? `${s.rank}º` : '—'}</b><span>{s.rank ? `de ${n(s.players)} heróis` : 'ainda sem dano'}</span></div>
        <div><small>Heróis na luta</small><b>{n(s.players)}</b><span>em todo o servidor</span></div>
        <div><small>Dano do servidor</small><b>{n(dealt)}</b><span>{(100 - pct).toFixed(1)}% da vida</span></div>
      </div>

      <div class="th-loot">
        <span>💰 Gold</span><span>💠 Fragmentos de pedra de proteção</span><span>🃏 Prey cards</span>
        <small>As recompensas são proporcionais ao dano. Quem cai na batalha final sai por {THREAT_FALL_MS / 60_000} minutos e volta, sem perda.</small>
      </div>

      {s.final && (
        <div class="th-cta">
          <span>{fall > 0 ? '💫 Você caiu: aguarde para voltar à arena.' : !props.inCity ? '🔒 Volte para a cidade para entrar na arena.' : '🔥 A arena está aberta!'}</span>
          <button class="tb-button green" disabled={!props.inCity || fall > 0} onClick={props.onEnter}>{fall > 0 ? `Volta em ${Math.ceil(fall / 1000)} s` : !props.inCity ? 'Volte para a cidade' : 'Entrar na batalha final'}</button>
        </div>
      )}
    </div>
  );
}
